module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.currentUserRole > 0) ? _c('div', {
    attrs: {
      "id": "pageNotFoundComponent"
    }
  }, [_c('h1', [_vm._v("😕")]), _vm._v(" "), _c('h2', [_vm._v("Oh no! How did you get here?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/surveyview"
    }
  }, [_vm._v("Click here to get back on track")])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ecb0bf40","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageNotFound.vue
// module id = 424
// module chunks = 1 2